
__webpack_require__.S = {};
__webpack_require__.initializeSharingData = { scopeToSharingDataMapping: { "default": [{ name: "@nackle/biw-web-router", version: "1.4.2", factory: () => (Promise.all([__webpack_require__.e("401"), __webpack_require__.e("69")]).then(() => (() => (__webpack_require__(85840))))), eager: 0 }, { name: "@nackle/bridge", version: "3.0.43", factory: () => (Promise.all([__webpack_require__.e("667"), __webpack_require__.e("737")]).then(() => (() => (__webpack_require__(16054))))), eager: 0 }, { name: "@nackle/intl-tools", version: "2.0.18", factory: () => (Promise.all([__webpack_require__.e("479"), __webpack_require__.e("864"), __webpack_require__.e("641")]).then(() => (() => (__webpack_require__(43106))))), eager: 0 }, { name: "@nackle/origami-icons", version: "1.7.2", factory: () => (Promise.all([__webpack_require__.e("539"), __webpack_require__.e("922")]).then(() => (() => (__webpack_require__(43222))))), eager: 0 }, { name: "@nackle/umbrella-studio", version: "1.5.32", factory: () => (__webpack_require__.e("142").then(() => (() => (__webpack_require__(80725))))), eager: 0 }, { name: "@nackle/umbrella", version: "2.1.27", factory: () => (Promise.all([__webpack_require__.e("504"), __webpack_require__.e("213")]).then(() => (() => (__webpack_require__(85907))))), eager: 0 }, { name: "antd", version: "5.29.3", factory: () => (Promise.all([__webpack_require__.e("210"), __webpack_require__.e("541"), __webpack_require__.e("644"), __webpack_require__.e("199")]).then(() => (() => (__webpack_require__(39961))))), eager: 0 }, { name: "react-dom", version: "18.3.1", factory: () => (() => (__webpack_require__(8143))), eager: 1 }, { name: "react", version: "18.3.1", factory: () => (() => (__webpack_require__(30758))), eager: 1 }] }, uniqueName: "shell-studio" };
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if (!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if (!initToken) initToken = initTokens[name] = {};
	if (initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if (initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if (!__webpack_require__.o(__webpack_require__.S, name))
		__webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function (msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = __webpack_require__.initializeSharingData.uniqueName;
	var register = function (name, version, factory, eager) {
		var versions = (scope[name] = scope[name] || {});
		var activeVersion = versions[version];
		if (
			!activeVersion ||
			(!activeVersion.loaded &&
				(!eager != !activeVersion.eager
					? eager
					: uniqueName > activeVersion.from))
		)
			versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function (id) {
		var handleError = function (err) {
			warn("Initialization of sharing external failed: " + err);
		};
		try {
			var module = __webpack_require__(id);
			if (!module) return;
			var initFn = function (module) {
				return (
					module &&
					module.init &&
					module.init(__webpack_require__.S[name], initScope)
				);
			};
			if (module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if (initResult && initResult.then)
				return promises.push(initResult["catch"](handleError));
		} catch (err) {
			handleError(err);
		}
	};
	var promises = [];
	var scopeToSharingDataMapping = __webpack_require__.initializeSharingData.scopeToSharingDataMapping;
	if (scopeToSharingDataMapping[name]) {
		scopeToSharingDataMapping[name].forEach(function (stage) {
			if (typeof stage === "object") register(stage.name, stage.version, stage.factory, stage.eager);
			else initExternal(stage)
		});
	}
	if (!promises.length) return (initPromises[name] = 1);
	return (initPromises[name] = Promise.all(promises).then(function () {
		return (initPromises[name] = 1);
	}));
};

